import React from 'react'
import { Navbar, Footer } from '..'
import '../../styles/global.css'

type LayoutProps = {
    children:React.ReactNode
}

const Layout:React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="layout">
            <Navbar />
            <div className="content">
                {children}
            </div>
            <Footer />
        </div>
    )
}

export default Layout
